export type ConcurrentField = {
  field: string
  base: unknown
  current: unknown
  mine: unknown
}

export type OrganizationKey = {
  dirLib: string
  domLib?: string | null
  ageLib?: string | null
  equLib?: string | null
}

export class ConcurrentChangeError extends Error {
  readonly status = 409

  readonly fields: ConcurrentField[]

  readonly currentKey: OrganizationKey | null

  constructor(
    message: string,
    readonly code: 'concurrentChange' | 'deleted',
    fields: ConcurrentField[],
    currentKey: OrganizationKey | null
  ) {
    super(message)
    this.name = 'ConcurrentChangeError'
    this.fields = fields
    this.currentKey = currentKey
  }
}
